import React, { useEffect, useState } from "react";
import { getFutureHolydays } from "services/workTime/get-future-holydays";
import { deleteHolyday } from "services/workTime/delete-holyday";
import { HolidayList } from "modules/calendar-worktime-holiday";
import styles from "./singelWorkTime.module.css";
import { FaRegTrashAlt } from "react-icons/fa";
import Popup from "components/Popup/popup";
import SuccessPopup from "components/successPopup/successPopup";

export default function HolydayList() {
    const [holidays, setHolidays] = useState<HolidayList[]>([]);
    const [isPopupOpen, setIsPopupOpen] = useState(false);
    const [selectedHoliday, setSelectedHoliday] = useState<HolidayList | null>(null);
    const [isSuccessPopupOpen, setIsSuccessPopupOpen] = useState(false);

    const fetchData = async () => {
        try {
            const res = await getFutureHolydays();
            setHolidays(res.data);
        } catch (error) {
            console.error("Error fetching data:", error);
        }
    };

    const handleDeleteConfirm = async () => {
        if (selectedHoliday) {
            try {
                await deleteHolyday(selectedHoliday.id);
                setHolidays((prevHolidays) =>
                    prevHolidays.filter((holiday) => holiday.id !== selectedHoliday.id)
                );
                setIsSuccessPopupOpen(true); 
            } catch (error) {
                console.error("Error deleting holiday:", error);
                alert("Fehler beim Löschen des Feiertags. Bitte versuchen Sie es erneut.");
            }
        }
    };

    const handleDeleteClick = (holiday: HolidayList) => {
        setSelectedHoliday(holiday);
        setIsPopupOpen(true);
    };

    const closePopup = () => {
        setIsPopupOpen(false);
        setSelectedHoliday(null);
    };

    useEffect(() => {
        fetchData();
    }, []);

    return (
        <div className={styles.container}>
            {holidays.length > 0 ? (
                <ul>
                    {holidays.map((holiday, index) => (
                        <li key={index}>
                            <div className={styles.holydayLine}>
                                {new Date(holiday.date).toLocaleDateString()}
                                {holiday.is_full_day ? (
                                    <p>Ganzer Tag</p>
                                ) : (
                                    <p>{holiday.start_time} - {holiday.end_time}</p>
                                )}
                            </div>
                            <button
                                type="button"
                                className={styles.removeButton}
                                onClick={() => handleDeleteClick(holiday)}
                            >
                                <FaRegTrashAlt />
                            </button>
                        </li>
                    ))}
                </ul>
            ) : (
                <div>Es gibt keine Feien</div>
            )}

            {isPopupOpen && selectedHoliday && (
                <Popup
                    title="Feiertag löschen"
                    submitLabel="Bestätigen"
                    closeLabel="Abbrechen"
                    isOpen={isPopupOpen}
                    onClose={closePopup}
                    onSubmit={handleDeleteConfirm}
                    isWithButton={true}
                >
                    <p>Sind Sie sicher, dass Sie diesen Feiern am {new Date(selectedHoliday.date).toLocaleDateString()} {!selectedHoliday.is_full_day ? selectedHoliday.start_time : ''} - {!selectedHoliday.is_full_day ? selectedHoliday.end_time : ''} löschen möchten?</p>

                </Popup>
                
            )}
             <SuccessPopup isPopupOpen={isSuccessPopupOpen} onClose={() => {
                            closePopup();
                            setIsSuccessPopupOpen(false);
                        }} />
        </div>
    );
}
